export type RecentlyViewedSurface = "homepage" | "pdp";

/** Payload nested under Monarch `data` (Cohesion rule `recentlyViewedProducts`). */
export type RecentlyViewedMonarchData = {
  homepageEnabled?: boolean;
  pdpEnabled?: boolean;
  homepageMaxRows?: number;
  /** Min items before showing the module (Monarch UI may use this name). */
  homepageMinViews?: number;
  /** Alias from Monarch custom fields — treated like `homepageMinViews`. */
  homepageMinItemsToRender?: number;
  recencyDays?: number;
  moduleTitle?: string;
  pdpMaxProducts?: number;
  pdpMinViews?: number;
  /** Alias from Monarch custom fields — treated like `pdpMinViews`. */
  pdpMinItemsToRender?: number;
};

/**
 * Normalized rule payload for enable checks + tunables (after
 * {@link unwrapRecentlyViewedMonarchValue}).
 *
 * Cohesion often returns a **variant** object where tunables live at
 * `value.data.data` and the master switch is `value.data.enabled` (mapped to `enable`).
 */
export type RecentlyViewedMonarchApiValue = {
  /** When `false`, suppress Recently Viewed on all surfaces (test mode). */
  enable?: boolean;
  data?: RecentlyViewedMonarchData;
};

/** Cohesion Monarch custom rule id — must match Monarch UI. */
export const RECENTLY_VIEWED_MODULE_RULE_ID = "recentlyViewedProducts";
